export function convertObjectToQueryString(filters) {
	let queryString = ''
	Object.entries(filters).forEach(([key, value], i) => {
		if (value !== null && value !== 'true') {
			queryString += `&${key}=${value}`
		}
	})
	return queryString
}
